import { render, staticRenderFns } from "./StudyChapter.vue?vue&type=template&id=4518987c&scoped=true&"
import script from "./StudyChapter.vue?vue&type=script&lang=js&"
export * from "./StudyChapter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518987c",
  null
  
)

export default component.exports